"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVisible = exports.toggleFilterButton = exports.hasFilterSelected = exports.isMobile = exports.handleClickCloseModal = exports.nthIndex = exports.redirectCallbacks = exports.ajaxResponseRedirectIfNeeded = exports.storageAvailable = exports.sortNumber = exports.GetArrayFromElement = exports.showErrorMessage = exports.removeLoadingIcon = exports.addLoadingIcon = void 0;
var features_filter_bar_mobile_1 = require("./features-filter-bar-mobile");
var IframeComms = require("./frame-comms/iframe-comms");
var BreadCrumbBuilder = require("./breadcrumb-builder");
function addLoadingIcon(id) {
    $(id).append($("#generic-loading-icon-container").html());
}
exports.addLoadingIcon = addLoadingIcon;
function removeLoadingIcon(id) {
    $(id + " .loading-icon-container").remove();
}
exports.removeLoadingIcon = removeLoadingIcon;
function showErrorMessage(message) {
    $("#generic-error-modal #error-text").text(message);
    $("#generic-error-modal").modal("show");
}
exports.showErrorMessage = showErrorMessage;
function GetArrayFromElement(elements) {
    if (elements) {
        if (!Array.isArray(elements)) {
            var brand = elements;
            var array = [brand];
            return array;
        }
        else {
            return elements;
        }
    }
    else {
        return [];
    }
}
exports.GetArrayFromElement = GetArrayFromElement;
function sortNumber(a, b) {
    return a - b;
}
exports.sortNumber = sortNumber;
function storageAvailable(type) {
    try {
        var storage = window[type], x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.storageAvailable = storageAvailable;
function ajaxResponseRedirectIfNeeded(data, callBack) {
    if (data.redirectToOtherApp) {
        addLoadingIcon("body");
        $("body").addClass("loading-content");
        window.location.replace(newUrlData);
    }
    else if (data.redirect) {
        addLoadingIcon("body");
        $("body").addClass("loading-content");
        var newUrlData = window.BaseUrl + "/" + window.MemberNr + "/" + data.dataVersion;
        window.location.replace(window.location.href.replace(window.BaseUrlWithVersions, newUrlData));
    }
    else {
        callBack();
    }
}
exports.ajaxResponseRedirectIfNeeded = ajaxResponseRedirectIfNeeded;
function redirectCallbacks(firstNavigationCallback, appCallBack) {
    if (History.storedStates.length > 2) {
        appCallBack();
    }
    else {
        firstNavigationCallback();
    }
}
exports.redirectCallbacks = redirectCallbacks;
function nthIndex(str, pat, n) {
    var L = str.length, i = -1;
    while (n-- && i++ < L) {
        i = str.indexOf(pat, i);
        if (i < 0)
            break;
    }
    return i;
}
exports.nthIndex = nthIndex;
function handleClickCloseModal(event) {
    event.stopPropagation();
    if (!$("#product-search-left-menu-wrapper").hasClass("active-over")) {
        $('#product-search-results').append('<div class="modal-backdrop fade in" id="bg-darken"> </div>');
        // Dark background control, plus closing when clicked outside event
        $("#bg-darken").off("click");
        $("#bg-darken").click(function (event) {
            if ($(".mobile").css("display") == "block" && $("#product-search-left-menu-wrapper").hasClass("active-over")) {
                $("#bg-darken").remove();
                $("#product-search-left-menu-wrapper").removeClass("active-over");
                $("#product-search-left-menu-wrapper").fadeToggle();
            }
        });
        $("#product-search-left-menu-wrapper").addClass("active-over");
    }
    else {
        $("#bg-darken").remove();
        $("#product-search-left-menu-wrapper").removeClass("active-over");
    }
    $("#product-search-left-menu-wrapper").fadeToggle();
}
exports.handleClickCloseModal = handleClickCloseModal;
function isMobile() {
    return $(".mobile").css("display") == "block";
}
exports.isMobile = isMobile;
function hasFilterSelected() {
    if ($(".feature-value-item").hasClass("selected") || $("#brands-filter-bar-mobile").find("input[type=checkbox]:checked").length > 0) {
        return true;
    }
    return false;
}
exports.hasFilterSelected = hasFilterSelected;
function toggleFilterButton() {
    if (hasFilterSelected()) {
        $(features_filter_bar_mobile_1.FeaturesFilterBarMobile.mobileFilterButtonSelector).addClass("filter-selected");
    }
    else {
        $(features_filter_bar_mobile_1.FeaturesFilterBarMobile.mobileFilterButtonSelector).removeClass("filter-selected");
    }
}
exports.toggleFilterButton = toggleFilterButton;
function isVisible(selector) {
    var selectedElement = document.getElementById(selector);
    if (selectedElement == null || selectedElement.style.display == "none") {
        return false;
    }
    return true;
}
exports.isVisible = isVisible;
